import React from 'react'

export default props =>
    <React.Fragment>
        <div className="col-2 mx-auto mb-5">
            <button className="btn btn-success"
                { ...props } >
                Enviar
            </button>
        </div>
    </React.Fragment>